import React from "react";
import { Button, Form } from 'react-bootstrap';
import "./forget.css";




const Forget = ({handleModal}) => {

    return (
            <div className="forget-password-section">
                <div className="forget-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="forget-form">
                                    <h1>Forget your <span>Password?</span></h1>
                                    <p>Enter your email to reset your password</p>
                                    <div className="forget-box">
                                        <Form>
                                            <Form.Group controlId="formBasicloginone">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control type="email" placeholder="Enter your email" name="email"  />                                                
                                            </Form.Group>
                                            <div className="login-button">
                                            <Button className="l-btn" onClick={()=>handleModal("reset")}>
                                                Continue
                                            </Button>
                                        </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Forget;